<!--
component: Dialog
author: Ken Nakamura
description: 汎用ダイアログコンポーネント
-->
<template>
  <div class="text-center">
    <v-dialog id="dialog" :width="width" v-model="open" persistent>
      <v-card>
        <v-card-title>
          <v-icon large color="primary" v-show="search">mdi-database-search</v-icon>&nbsp;
          {{ title }}
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row align="center" class="ma-1">
            <v-col cols="2" class="pa-0" align="center">
              <v-icon large color="error" class="ma-auto" v-if="error">mdi-alert</v-icon>
              <v-icon large color="success" class="ma-auto" v-else-if="message">mdi-check-circle</v-icon>
            </v-col>
            <v-col cols="10">{{ body }}</v-col>
          </v-row>
          <v-progress-linear v-show="search"
            color="light-blue darken-2"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions class="pt-1">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeBtnClick" v-show="closeVisible">閉じる</v-btn>
          <v-btn text color="primary" @click="okBtnClick()" v-show="okVisible">OK</v-btn>
          <v-btn text color="primary" @click="cancelBtnClick()" v-show="cancelVisible">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { dbglog } from '../common/utils'

export default {
  data () {
    return {
    }
  },
  props: {
    /** ダイアログ表示のトリガー */
    open: {
      type: Boolean,
      default: false,
    },
    /** 検索進捗表示 */
    search: {
      type: Boolean,
      default: false,
    },
    /** エラー表示 */
    error: {
      type: Boolean,
      default: false,
    },
    /** メッセージ表示 */
    message: {
      type: Boolean,
      default: false,
    },
    /** ダイアログ表題 */
    title: {
      type: String,
      default: '',
    },
    /** ダイアログ本文 */
    body: {
      type: String,
      default: '',
    },
    /** 閉じた時の遷移先 */
    to: {
      type: String,
      default: '',
    },
    /** 閉じるボタンが押された時に呼ばれる関数 */
    close: {
      type: Function,
      default: null,
    },
    /** OKボタンが押された時に呼ばれる関数 */
    ok: {
      type: Function,
      default: null,
    },
    /** キャンセルボタンが押された時に呼ばれる関数 */
    cancel: {
      type: Function,
      default: null,
    },
    /** ダイアログの横幅 */
    width: {
      type: String,
      default: '50%',
    }
  },
  mounted () {
  },
  computed: {
    closeVisible() {
      return this.close !== null;
    },
    okVisible() {
      return this.ok !== null || this.to != '' ;
    },
    cancelVisible() {
      return this.cancel !== null;
    },
  },
  methods: {
    closeBtnClick () {
      if (this.to.length) {
        dbglog(`Dialog.closeBtnClick: ${this.to}`);
        if (this.to == 'back') {
          this.$router.back();
        }
        else {
          this.$router.replace(this.to);
        }
        return;
      }
      if (this.close) {
        this.close();
      }
    },
    okBtnClick () {
      if (this.to.length) {
        dbglog(`Dialog.okBtnClick: ${this.to}`);
        if (this.to == 'back') {
          this.$router.back();
        }
        else {
          this.$router.replace(this.to);
        }
        return;
      }
      if (this.ok) {
        this.ok();
      }
    },
    cancelBtnClick () {
      try {
        if (this.to.length) {
          dbglog(`Dialog.okBtnClick: ${this.to}`);
          if (this.to == 'back') {
            this.$router.back();
          }
          else {
            this.$router.replace(this.to);
          }
          return;
        }
        if (this.cancel) {
          this.cancel();
        }
      }
      catch (e) {
        dbglog(`Dialog.cancelBtnClick: ${e}`, -1);
      }
    },
  }
}
</script>